import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { DashboardProvider } from '../context/DashboardContext'
import Header from 'components/Header'
import useAxiosInterceptor from 'hooks/useAxiosInterceptor'
import LoadingPage from './LoadingPage'

const DashboardContainer = () => {
  const { isInterceptorReady } = useAxiosInterceptor()
  return (
    <DashboardProvider>
      <Header />
      {isInterceptorReady ? <Outlet /> : <LoadingPage />}
    </DashboardProvider>
  )
}

export default DashboardContainer
